export const YEAR_CHANGE: 'YEAR_CHANGE' = 'YEAR_CHANGE';
export const QUERY_SELECT_ONE_CHANGE: 'QUERY_SELECT_ONE_CHANGE' =
  'QUERY_SELECT_ONE_CHANGE';
export const QUERY_SELECT_TWO_CHANGE: 'QUERY_SELECT_TWO_CHANGE' =
  'QUERY_SELECT_TWO_CHANGE';
export const QUERY_SELECT_THREE_CHANGE: 'QUERY_SELECT_THREE_CHANGE' =
  'QUERY_SELECT_THREE_CHANGE';
